<template>
  <div>
    <!-- テーブル1: 基本情報 -->
    <table class="info__table" style="margin-bottom: 20px;">
      <tbody>
        <tr>
          <th>職種</th>
          <td>{{ order.displayed_wanted_jobs }}</td>
        </tr>
        <tr>
          <th>施設<br class="is-sp">形態</th>
          <td>{{ order.hospital_workplace_type }}</td>
        </tr>
        <tr>
          <th>勤務地</th>
          <td>
            {{ order.work_location }}
            <div id="office_map" style="height: 300px; z-index: 0;" v-show="this.isDisplayedMap">
            </div>
          </td>
        </tr>
        <tr>
          <th>求人<br class="is-sp">概要</th>
          <td style="white-space: pre-wrap;">{{ order.work_contents_memo }}</td>
        </tr>
        <tr>
          <th>勤務<br class="is-sp">時間</th>
          <td style="white-space:pre-wrap;">{{ order.job_time }}</td>
        </tr>
        <tr>
          <th>休日</th>
          <td>{{ order.displayed_fulltime_off_days_of_weeks }}</td>
        </tr>
        <tr>
          <th>想定<br class="is-sp">年収</th>
          <td style="white-space:pre-wrap;">{{ order.displayed_expected_salary }}</td>
        </tr>
      </tbody>
    </table>
    <!-- モザイク画像 -->
    <div class="info__mosaic-section" v-if="assetsImagePath">
      <a href="#contact" class="info__mosaic-link">
        <img :src="assetsImagePath.mosaic_pc" alt="詳細情報を見るには問い合わせが必要です" class="info__mosaic-img is-pc" v-if="assetsImagePath.mosaic_pc">
        <img :src="assetsImagePath.mosaic_sp" alt="詳細情報を見るには問い合わせが必要です" class="info__mosaic-img is-sp" v-if="assetsImagePath.mosaic_sp">
      </a>
    </div>
  </div>
</template>
<script>
export default {
  name: 'InformationTable',
  props: ['order', 'isDisplayedMap', 'assetsImagePath'],
}
</script>
